import { AxiosResponse } from 'axios';
import { IDashboardProjectionPoint } from "../Interfaces/IDashboardProjectionPoint";
import { IDashboardFilterData } from "../Interfaces/IDashboardFilterData";
import { DashboardOptions } from "../types/dashboardOptions";
import { API } from "./config";

const routeConfig: Record<string, string> = {
  "saída": "status",
  "entrada": "status",
  "saldo": "balance"
}

export const dashboardService = {
  async filter(
    filter: Required<IDashboardFilterData>,
    bankId: number,
    status: DashboardOptions,
    token: string
  ): Promise<AxiosResponse<{ amount: number }>> {
    const { finalDate, initialDate, consumer } = filter;
    const data = {
      status,
      userID: consumer,
      initialDate,
      finalDate,
    };
    const route = routeConfig[status] ? routeConfig[status] : 'classification';
    return await API.post(`/dashboard/${route}`, { ...data, bankId }, { headers: { 'Authorization': `Bearer ${token}` } });
  },

  async projection10Days(
    userId: number,
    token: string,
    bankId?: number
  ): Promise<AxiosResponse<{ data: IDashboardProjectionPoint[]; initialBalance: number }>> {
    const params = new URLSearchParams();
    params.append('userID', String(userId));
    if (typeof bankId === 'number' && bankId !== 0) {
      params.append('bankId', String(bankId));
    }

    return await API.get(`/dashboard/projection10days?${params.toString()}`, { headers: { 'Authorization': `Bearer ${token}` } });
  }
}
